export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-[#0a0a0f] to-[#000000] py-16 px-4 border-t border-gray-800">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="https://public.readdy.ai/ai/img_res/6187dda7-4ee3-4144-a653-0e0d186c3a43.png" alt="Logo" className="w-12 h-12 object-contain" />
              <span className="text-2xl font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent">
                Live Casino 2026
              </span>
            </div>
            <p className="text-gray-400 mb-6">
              Рейтинг лучших live-казино с профессиональными дилерами. Играйте в HD качестве с быстрыми выплатами.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-[#242429] rounded-full flex items-center justify-center hover:bg-[#d4af37] transition-colors">
                <i className="ri-telegram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-[#242429] rounded-full flex items-center justify-center hover:bg-[#d4af37] transition-colors">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-[#242429] rounded-full flex items-center justify-center hover:bg-[#d4af37] transition-colors">
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4 text-[#d4af37]">Навигация</h4>
            <ul className="space-y-3">
              <li><a href="/" className="text-gray-400 hover:text-[#d4af37] transition-colors">Главная</a></li>
              <li><a href="/rating" className="text-gray-400 hover:text-[#d4af37] transition-colors">Рейтинг казино</a></li>
              <li><a href="/providers" className="text-gray-400 hover:text-[#d4af37] transition-colors">Провайдеры live-игр</a></li>
              <li><a href="#glossary" className="text-gray-400 hover:text-[#d4af37] transition-colors">Глоссарий</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4 text-[#d4af37]">Важная информация</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-wifi-line text-[#d4af37] text-xl mt-1"></i>
                <p className="text-gray-400 text-sm">
                  Для комфортной игры требуется стабильное интернет-соединение со скоростью от 5 Мбит/с
                </p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-error-warning-line text-[#c41e3a] text-xl mt-1"></i>
                <p className="text-gray-400 text-sm">
                  Азартные игры могут вызывать зависимость. Играйте ответственно. 18+
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © 2026 Live Casino. Все права защищены. Информация на сайте носит ознакомительный характер.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-[#d4af37] transition-colors text-sm"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}